export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#gift-card","viewBox":"0 0 28 20"}